import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

const SET_STATUSES = 'SET_STATUSES'

export default {
  namespaced: true,
  state: {
    statusesByKey: {}
  },
  getters: {
    getStatuses: (state) => (key) => state.statusesByKey[key]
  },
  mutations: {
    [SET_STATUSES](state, { key, statuses }) {
      state.statusesByKey = { ...state.statusesByKey, [key]: statuses }
    }
  },
  actions: {
    async fetchAccreditationStatuses({ commit, getters }, { tenderId, supplierId, categoryIds }) {
      const key = `${tenderId}_${supplierId}`
      const cached = getters.getStatuses(key)
      if (cached) {
        return cached
      }
      const statuses = await api.invitedParticipantsAccreditations(categoryIds, supplierId) ?? []
      commit(SET_STATUSES, { key, statuses })
      return statuses
    }
  }
}
